// Udyan 2 Oct: homepage product tabs ("Customer Favourites / New In", "Gifts / Teaware / Combo Packs").
// Only the first tab of each section is built when the page loads; the others wait in a <template data-ut-tab="N">
// (sections/featured-collection.liquid) and are built the first time their tab is tapped. This listens in the capture
// phase, so the tab exists before custom.js shows it.
(function () {
  if (window.utTabsReady) return; // the script tag is printed once per tabbed section
  window.utTabsReady = true;

  document.addEventListener(
    'click',
    function (event) {
      var tab = event.target.closest && event.target.closest('.tab-title');
      if (!tab) return;
      var section = tab.closest('.collection');
      if (!section) return;
      var template = section.querySelector('template[data-ut-tab="' + tab.getAttribute('data-index') + '"]');
      if (template) template.replaceWith(document.importNode(template.content, true));
    },
    true
  );
})();
